import { dialCodeForIso, TRIAL_DIAL_CODES } from "./trial-phone.utils";

interface PhoneFieldWithDialCodeProps {
  id?: string;
  dialCode: string;
  localNumber: string;
  onDialCodeChange: (dialCode: string) => void;
  onLocalNumberChange: (local: string) => void;
  required?: boolean;
  disabled?: boolean;
  label?: string;
}

export function PhoneFieldWithDialCode({
  id = "phone",
  dialCode,
  localNumber,
  onDialCodeChange,
  onLocalNumberChange,
  required = false,
  disabled = false,
  label = "Téléphone",
}: PhoneFieldWithDialCodeProps) {
  return (
    <div>
      <label className="form-label" htmlFor={id}>
        {label}
        {required ? " *" : ""}
      </label>
      <div className="input-group">
        <select
          className="form-select flex-shrink-0"
          style={{ maxWidth: "7.5rem" }}
          value={dialCode}
          aria-label="Indicatif pays"
          disabled={disabled}
          onChange={(e) => onDialCodeChange(e.target.value)}
        >
          {TRIAL_DIAL_CODES.map((c) => (
            <option key={c.iso} value={c.dial}>
              {c.dial}
            </option>
          ))}
        </select>
        <input
          id={id}
          type="tel"
          className="form-control"
          value={localNumber}
          onChange={(e) => onLocalNumberChange(e.target.value)}
          placeholder="812 345 678"
          required={required}
          minLength={8}
          disabled={disabled}
          autoComplete="tel-national"
        />
      </div>
      <div className="form-text">Saisissez le numéro sans l&apos;indicatif pays.</div>
    </div>
  );
}

/** Met à jour l'indicatif quand le pays ISO change (GeoLocationFields). */
export function syncDialCodeFromCountry(isoCode: string, currentDial: string): string {
  if (!isoCode) return currentDial;
  return dialCodeForIso(isoCode);
}
